import type { Listing } from '@thevillages/schemas';

import { CurrencyPipe } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';

import { ComputedListingBaths, ComputedListingOpenNow } from '../../../computed-values';
import { StateService } from '../../../services/state/state';
import { SaveListing } from '../../save-listing/save-listing';
import { HomeListingCardFeatures } from './features/features';
import { HomeListingCardOpenHouse } from './open-house/open-house';
import { PlaceholderImage } from './placeholder-image';

@Component({
  imports: [
    CurrencyPipe,
    DecimalPipe,
    HomeListingCardFeatures,
    HomeListingCardOpenHouse,
    NgOptimizedImage,
    SaveListing,
  ],
  providers: [PlaceholderImage],
  selector: 'app-home-listing-card',
  styleUrl: './home.css',
  templateUrl: './home.html',
})
export class HomeListingCard {
  protected readonly stateService = inject(StateService);

  public readonly initialRender = input(false);
  public readonly listing = input.required<Listing>();
  public readonly saveClicked = output();

  protected readonly baths = computed(() => ComputedListingBaths(this.listing()));
  protected readonly openNow = computed(() => ComputedListingOpenNow(this.listing()));
}
